import { filePreview, fileSave, fileDelete, fileCopy } from "@/api/files.api";

import { attributeValueUpdate } from "@/api/attributeValue.api";

const state = {
  imgSrc: undefined,
  cropImg: "",
  previewImgUrl: "",
  data: null,
  rotateDeg: 90,
  aspectRatio: undefined,
  widthImgage: 400,
  heightImage: 272,
  qualityImage: 70,
  imgProcessing: false,
  cropMe: false
};

const getters = {};

const actions = {
  async filePreview({ commit, state }, { lang, fileName }) {
    commit("setImgProcessing", true);
    try {
      const response = await filePreview(
        state.cropImg,
        fileName,
        lang,
        state.qualityImage,
        state.widthImgage,
        state.heightImage
      );
      commit("setFilePreview", response.data.url);
      commit("setImgProcessing", false);
      // return response.status;
    } catch (err) {
      commit("setImgProcessing", false);
      // return err.response.status;
    }
  },
  async fileSave({ commit, state }, { objectId, attributeId, lang, fileName }) {
    try {
      const response = await fileSave(
        state.cropImg,
        fileName,
        lang,
        objectId,
        attributeId,
        state.qualityImage,
        state.widthImgage,
        state.heightImage
      );
      commit("setImgProcessing", false);
      return response.data;
    } catch (err) {
      commit("setImgProcessing", false);
      return err.response;
    }
  },
  async fileDelete(undefined, { data, lang }) {
    try {
      const response = await fileDelete(data, lang);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async fileCopy(undefined, { data, lang }) {
    try {
      const response = await fileCopy(data, lang);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  },
  async fileDescriptionSave(undefined, { id, lang, data }) {
    try {
      const response = await attributeValueUpdate(id, lang, data);
      return response.data;
    } catch (err) {
      return err.response.status;
    }
  }
};

const mutations = {
  updateRotateDeg(state, val) {
    state.rotateDeg = val;
  },
  updateData(state, val) {
    state.data = val;
  },
  recalcAspectRatio(state) {
    state.aspectRatio = state.widthImgage / state.heightImage;
  },
  setCropImage(state, val) {
    state.cropImg = val;
  },
  setSourceImage(state, val) {
    state.imgSrc = val;
  },
  setSizeImage(state, { width, height }) {
    state.widthImgage = width;
    state.heightImage = height;
  },
  setQualityImage(state, val) {
    state.qualityImage = val;
  },
  setImgProcessing(state, val) {
    state.imgProcessing = val;
  },
  setFilePreview(state, url) {
    state.previewImgUrl = url;
  },
  clearPictureEditor(state) {
    state.imgSrc = undefined;
    state.cropImg = "";
    state.previewImgUrl = "";
    state.data = null;
    state.rotateDeg = 90;
    state.aspectRatio = undefined;
    state.widthImgage = 400;
    state.heightImage = 272;
    state.qualityImage = 70;
    state.imgProcessing = false;
    state.cropMe = false;
  },
  setCropMe(state, val) {
    state.cropMe = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
